import { WalletResponseDto } from 'src/generated-sources/openapi/wallet-service/wallet';
import { TableConfig } from 'src/app/shared/components/generic-table';
import {
  createWalletTableConfig,
  WalletColumnKeys,
} from 'src/app/shared/table-configs/wallet-table-config.base';

export type WalletFavoriteColumnKeys = WalletColumnKeys;

export const WALLET_FAVORITE_NO_DATA_MESSAGE = $localize`:@@noDataFavoriteWalletDisplay:No hay datos para mostrar.`;

export const getWalletFavoriteTableConfig = (): TableConfig<
  WalletResponseDto,
  WalletFavoriteColumnKeys
> => createWalletTableConfig();

export const walletFavoriteTableConfig = getWalletFavoriteTableConfig();
